import React from 'react';
import styled from 'styled-components';
import { Statistic } from 'antd';
import Color from '../../../enums/color';
import FlexContainer from '../FlexContainer';
import { KPMGConfirmActiveIcon } from '../../../assets/icons';
import { getIdleConfirmTimeout } from '../../../helpers/idle';
const Countdown = styled(Statistic.Countdown) `
  .ant-statistic-content {
    color: ${Color.CuriousBlue};
    font-size: 62px;
    font-weight: bold;
  }
`;
const CountdownIcon = ({ onFinish }) => (<FlexContainer alignItems='center' gap='16px'>
    <KPMGConfirmActiveIcon />
    <Countdown value={getIdleConfirmTimeout()} format='mm:ss' onFinish={onFinish}/>
  </FlexContainer>);
export default CountdownIcon;
